import { render, staticRenderFns } from "./DingUserInfoList.vue?vue&type=template&id=64d8f2bc&scoped=true"
import script from "./DingUserInfoList.vue?vue&type=script&lang=js"
export * from "./DingUserInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8f2bc",
  null
  
)

export default component.exports